import { useAppSelector } from "config/store";
import { useEffect, useState } from "react";
import ajax from "config/ajax.ts";

function LegalContentPage(props: { name: string, legalName: "policy" | "terms" }) {
  const { legalName } = props;
  const currentLang = useAppSelector(state => state.global.currentLang);


  const [htmlContent, setHtmlContent] = useState<string>("");

  useEffect(() => {
    ajax.get(`/public/legals/content`, {
      headers: {
        "Content-Type": "text/html"
      },
      params: {
        name: legalName,
        lang: currentLang
      }
    })
      .then(res => setHtmlContent(res.data));
  }, [currentLang, legalName]);


  return (
    <div className="container mx-auto py-12 md:py-24 pb-32 md:pb-40">
      <div className="prose">
        <div dangerouslySetInnerHTML={{ __html: htmlContent }}></div>
      </div>
    </div>
  );
}


export const TermsPage = ({ name }) => <LegalContentPage name={name} legalName={"terms"} />;
export const PolicyPage = ({ name }) => <LegalContentPage name={name} legalName={"policy"} />;


export default LegalContentPage;
